import React, { useEffect, useState } from 'react'
import '../../styles/Auth.css'
import { authTokenSelector } from '../../selectors'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import AuthSlideLayout from './auth-slide-layout'
import AuthStaticLayout from './auth-static-layout'
import config from 'custom/config/environment'

export default function AuthLayout({ children }) {
  const authToken = useSelector(authTokenSelector)
  const dispatch = useDispatch()
  const history = useHistory()
  const [pathName, setPathName] = useState([
    '/landing',
    '/login',
    '/forgot-password',
    '/forgot-username',
    '/landing/locateUs',
    '/landing/calculator',
    '/landing/exchangeRates',
    '/register',
  ])
  let pathExist = []
  let path = ''

  useEffect(() => {
    if (authToken !== null) {
      let event = window.event
      path = event?.oldURL?.split('#')[1] || ''
      if (path !== '') {
        pathExist = pathName?.filter((e) => e === path)
        if (pathExist?.length === 0) {
          dispatch({ type: 'USER_LOGOUT' })
          history.push('/login')
        }
      }
    }
  }, [authToken])

  return (
    <div className='container-fluid'>
      {config.AUTH_LAYOUT_TYPE === 'STATIC' && <AuthStaticLayout children={children} />}
      {config.AUTH_LAYOUT_TYPE === 'SLIDE' && <AuthSlideLayout children={children} />}
    </div>
  )
}
